import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
// import useCountValue from './selectors'
import {GET_SEARCH_RESULT} from './actionTypes'
import fetchData, {fetchContent} from '../../utils/fetch-data'
// import config from '../../config'
// import getLatLong from '../../utils/getLatLong'



async function getCityName({latitude, longitude}) {
  try {
    const url = `/event/ajax-citypage-redirect?zip=1&userLat=${latitude}&userLong=${longitude}&force=1&json=1`
    const result = await fetchData(url)
    // console.debug(result)
    return result
  } catch (e) {
    throw new Error('Error by getCityName')
  }
}

const useSearchActions = () => {
  const dispatch = useDispatch()
  const getLatLongResult = useCallback(
    async result => {
      // const result = await getLatLong(value)
      if (result.status === 1) {
        const cityDataJson = await getCityName(result)
        dispatch({
          type: GET_SEARCH_RESULT,
          payload: cityDataJson,
        })
      } else {
        dispatch({
          type: GET_SEARCH_RESULT,
          payload: 'Error by getLatLongResult',
        })
      }
    },
    [dispatch]
  )
  return {getLatLongResult}
}

export default useSearchActions
